import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const Bold = (props) => (
  <Icon viewBox="0 0 30 30" {...props}>
    <g>
      <path d="M11 15h4c.6 0 2 0 2-2 0-1.9-1.2-2-2-2h-4v4zm0 2v4h5c1.1 0 2-.5 2-2s-.9-2-2-2h-5zm0 6H9V11 9h5.9c1.5 0 2.6.6 3.4 1.8.8 1.2.9 2.8.2 4.1-.1.3-.3.5-.5.7 1.1.6 1.9 1.7 2 2.9.1 1.2-.2 2.2-1 3.1-.8.9-2 1.4-3.2 1.4H11z"
      />
    </g>
  </Icon>
);
/*eslint-enable */

export default Bold;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/Bold.js